export enum ORDER_PERMISSIONS {
  ORDER_VIEW = 'ORDER_VIEW',
  ORDER_WRITE = 'ORDER_WRITE',
  VIEW_PAYMENT_INFO = 'ORDER_VIEWCUSTOMERINFO',
  VIEW_CUSTOMER_INFO = 'ORDER_VIEWPAYMENTINFO',
  ORDER_STATUS_WRITE = 'ORDER_STATUSWRITE',
  ORDER_STATUS_VIEW = 'ORDER_STATUSVIEW',
  REPORT_FRAUD = 'CRM_USER_REPORTFRAUD'
}

export enum SUBORDER_PERMISSIONS {
  SUBORDER_VIEW = 'ORDER_SUBORDERVIEW',
  SUBORDER_WRITE = 'ORDER_SUBORDERWRITE',
}
